import { useCallback, useContext } from 'react'
import { toast } from 'react-toastify'
import GlobalContext from '../providers/GlobalContext'
import { updateUnifyPreference } from '../helpers/session'
import { UNIFY_ENABLED } from '../constants/env'

export const UNIFY_STAY_KEY = 'unify:stay'
export const UNIFY_PREVIEW_KEY = 'unify:preview'

export const shouldStayOnClassic = () => {
  try {
    return sessionStorage.getItem(UNIFY_STAY_KEY) === '1'
  } catch (err) {
    return false
  }
}

export const rememberStayOnClassic = () => {
  try {
    sessionStorage.setItem(UNIFY_STAY_KEY, '1')
  } catch (err) {
    // session storage unavailable
  }
}

export const unifyHomeFor = (loggedInUser) => {
  if (loggedInUser?.companyUuid) return `/company/${loggedInUser.companyUuid}/dashboards/overview`
  return '/'
}

export default function useUnify() {
  const { loggedInUser } = useContext(GlobalContext)

  const switchToUnify = useCallback(async ({ optIn = false } = {}) => {
    if (!UNIFY_ENABLED) return false
    try {
      if (optIn) sessionStorage.removeItem(UNIFY_PREVIEW_KEY)
      else sessionStorage.setItem(UNIFY_PREVIEW_KEY, '1')
    } catch (err) {
      // session storage unavailable; Unify falls back to the user's default
    }
    if (optIn) {
      let result
      try {
        result = await updateUnifyPreference({ ui: 'unify' })
      } catch (err) {
        result = { success: false, message: err?.message }
      }
      if (!result?.success) {
        toast(result?.message || 'Could not switch to Sematics Unify', { type: 'error' })
        return false
      }
    }
    window.location.assign(unifyHomeFor(loggedInUser))
    return true
  }, [loggedInUser])

  return { switchToUnify, unifyEnabled: UNIFY_ENABLED }
}
